import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.SignupLoginModule', {
    signUpText: 'Sign up',
    loginText: 'Log in',
    signUpWith: 'Or sign up with',
    loginWith: 'Or log in with',

    qbooksVerifyEmail: 'Please verify your Intuit account before it can be used with ApprovalMax',
    verify: 'Verify',
});
